import { Select, SelectProps } from "antd"; 
import { TipoDivisaoContaEnum } from "core/resources/enums/conta";
import SelectBaseAntd from "../SelectBaseAntd";

const { Option } = Select;

export interface SelectDivisaoParcelasProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
}

function SelectDivisaoParcelas({
  value,
  isInvalid,
  onChange,
  ...rest
}: SelectDivisaoParcelasProps) {
  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder="Tipo de recorrência"
        style={{ width: "100%" }}
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        <Option
          value={TipoDivisaoContaEnum.ParcelasTeraoMesmoValorLiquido}
          key="p"
        >
          As parcelas terão o mesmo valor do líquido
        </Option>
        <Option
          value={TipoDivisaoContaEnum.DividirValorLiquidoEntreParcelas}
          key="d"
        >
          Dividir o valor líquido entre as parcelas
        </Option>
      </SelectBaseAntd>
    </>
  );
}

export default SelectDivisaoParcelas;
